import { render, staticRenderFns } from "./faqManagement.vue?vue&type=template&id=7ebe8822"
import script from "./faqManagement.vue?vue&type=script&lang=js"
export * from "./faqManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports